import httpClient from './client';
import type {
  AxiosBaseQueryFn,
  TAxiosBaseQueryInput,
  TAxiosBaseRequestParams,
  TAxiosBaseResponseError,
  TAxiosBaseResponseSuccess,
} from './rtk-query.types';
import { isTAxiosInterceptorResponseError } from './rtk-query.types';

const axiosBaseQuery = ({ baseUrl }: TAxiosBaseQueryInput = { baseUrl: '' }): AxiosBaseQueryFn => {
  // @ts-ignore
  return async ({
    url,
    method,
    data,
    params,
    responseType,
    headers,
  }: TAxiosBaseRequestParams): Promise<TAxiosBaseResponseSuccess | TAxiosBaseResponseError> => {
    try {
      const result = await httpClient({
        url: baseUrl + url,
        method,
        data,
        params,
        responseType,
        headers: {
          ...headers,
          'Manager-Version': 'vite',
        },
      });
      return { data: result.data };
    } catch (error) {
      console.error('axiosBaseQuery error', error);
      // return axiosError;

      if (isTAxiosInterceptorResponseError(error)) {
        return {
          error: {
            status: error.status,
            statusText: error.statusText,
            data: error.data,
            message: error.message,
          },
        };
      }

      return {
        // @ts-ignore
        error,
      };
    }
  };
};

export default axiosBaseQuery;
